/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2019 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/

/* istanbul ignore file */

//  @ts-nocheck

/* eslint-disable no-unused-vars */
import Overlay from '@react/react-spectrum/OverlayTrigger/js/Overlay';
import LanguageSwitcherPosition from './LanguageSwitcherPosition';
import OpenTransition from '@react/react-spectrum/utils/OpenTransition';
import ownerDocument from 'react-overlays/lib/utils/ownerDocument';
import Portal from 'react-overlays/lib/Portal';
import React from 'react';
import ReactDOM from 'react-dom';
import RootCloseWrapper from 'react-overlays/lib/RootCloseWrapper';

/* eslint-enable no-unused-vars */
export default class LanguageSwitcherOverlay extends Overlay {
	render() {
		const {
			containerPadding,
			target,
			container = this.getOverlayContainer(target),
			placement,
			offset,
			crossOffset,
			flip,
			boundariesElement = () => ownerDocument(this).body,
			shouldUpdatePosition,
			rootClose,
			children,
			...props
		} = this.props;

		// Don't un-render the overlay while it's transitioning out.
		const mountOverlay = props.show || !this.state.exited;
		if (!mountOverlay) {
			// Don't bother showing anything if we don't have to.
			return null;
		}

		let child = children;

		// Position is be inner-most because it adds inline styles into the child,
		// which the other wrappers don't forward correctly.
		child = (
			<LanguageSwitcherPosition
				{...{
					container,
					containerPadding,
					target,
					placement,
					shouldUpdatePosition,
					offset,
					crossOffset,
					flip,
					boundariesElement,
				}}
			>
				{child}
			</LanguageSwitcherPosition>
		);

		// This animates the child node by injecting props, so it must precede
		// anything that adds a wrapping div.
		const {onExit, onExiting, onEnter, onEntering} = props;
		child = (
			<OpenTransition
				in={props.show}
				appear
				onExit={onExit}
				onExiting={onExiting}
				onExited={this.onExited}
				onEnter={onEnter}
				onEntering={onEntering}
				onEntered={this.onEntered}
			>
				{child}
			</OpenTransition>
		);

		// This goes after everything else because it adds a wrapping div.
		if (rootClose) {
			child = <RootCloseWrapper onRootClose={this.hide}>{child}</RootCloseWrapper>;
		}

		return <Portal container={container}>{child}</Portal>;
	}
}
